import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import inputStyle from './text-input.scss';
import TextInput from '../text-input/index';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';
import Button from '../button/index';
import { Download, Warning } from '../../helpers/icon-dictionary';
import messages from './messages';
import Modal from '../../components/modal/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import SignInCardsFormats from '../sign-in-cards-formats';

class StudentDetails extends Component {
    getChildren = () => {
        const { showEditStudentValidationModal,
            showModal,
            handleOnCloseValidationModal,
            editStudentValidationMessage,
            handleOnPrintSignInCard,
            isSignInCardDownloaded,
            handleOnCloseModal
        } = this.props;

        if (showEditStudentValidationModal) {
            return (<ConfirmationMessage handleOnCloseModal={handleOnCloseValidationModal} icon={Warning} >
                <div>{editStudentValidationMessage}</div>
            </ConfirmationMessage>);
        } else if (showModal) {
            return (<SignInCardsFormats
                handleOnCancel={handleOnCloseModal}
                handleOnDownloadSignInCards={handleOnPrintSignInCard}
                isSignInCardDownloaded={isSignInCardDownloaded} />);
        }
        return '<div />';
    }

    render() {
        return (
            <div>
                <div>
                    <div className={this.props.css.studentDetailHeader}>{this.props.intl.formatMessage(messages.studentDetails)}</div>
                    <div className={this.props.css.panel}>
                        <div className={this.props.css.leftPanel}>
                            <div>
                                <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.firstname)}</div>
                                <TextInput
                                    css={inputStyle}
                                    handleOnChange={this.props.handleOnTextInputChange}
                                    maxLength={50}
                                    name="firstName"
                                    value={this.props.student.firstName}
                                />
                            </div>
                            <div>
                                <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.lastname)}</div>
                                <TextInput
                                    css={inputStyle}
                                    handleOnChange={this.props.handleOnTextInputChange}
                                    maxLength={50}
                                    name="lastName"
                                    value={this.props.student.lastName}
                                />
                            </div>
                            <div>
                                <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.year)}</div>
                                <div className={this.props.css.list}>
                                    <DropDownList
                                        css={listStyle}
                                        name="yearGroupEnum"
                                        onChange={this.props.handleOnListChange}
                                        options={this.props.yearGroups}
                                        value={this.props.student.yearGroupEnum.toString()} /></div>
                            </div>
                        </div>
                        <div className={this.props.css.rightPanel}>
                            <div>
                                <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.username)}</div>
                                <TextInput
                                    css={inputStyle}
                                    disabled
                                    maxLength={50}
                                    name="userName"
                                    value={this.props.student.userName}
                                />
                            </div>
                            <div>
                                <div className={this.props.css.label}>{this.props.intl.formatMessage(messages.password)}</div>
                                <TextInput
                                    css={inputStyle}
                                    handleOnChange={this.props.handleOnTextInputChange}
                                    maxLength={50}
                                    name="password"
                                    value={this.props.student.password}
                                />
                            </div>
                            <div>
                                <div className={this.props.css.label} />
                                <div className={this.props.css.warning}> {this.props.intl.formatMessage(messages.warning)} </div>
                            </div>
                        </div>
                    </div>
                    <div className={this.props.css.signCardPanel}>
                        <Button
                            containerClassName={this.props.css.downloadSignInCards}
                            handleOnClick={this.props.downloadStudentsSignInCards}
                            icon={Download}
                            iconClassName={this.props.css.iconClassName}
                            label={this.props.intl.formatMessage(messages.downloadSignInCard)}
                        />
                    </div>
                </div>
                <Modal show={this.props.showEditStudentValidationModal || this.props.showModal} >
                    {this.getChildren()}
                </Modal>
            </div>
        );
    }
}

StudentDetails.propTypes = {
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    css: PropTypes.object,
    student: PropTypes.object,
    handleOnTextInputChange: PropTypes.func,
    handleOnListChange: PropTypes.func,
    showEditStudentValidationModal: PropTypes.bool,
    editStudentValidationMessage: PropTypes.string,
    handleOnCloseValidationModal: PropTypes.func,
    handleOnPrintSignInCard: PropTypes.func,
    isSignInCardDownloaded: PropTypes.bool,
    intl: intlShape.isRequired,
    showModal: PropTypes.bool,
    downloadStudentsSignInCards: PropTypes.func,
    handleOnCloseModal: PropTypes.func
};

export default injectIntl(styleable(css)(StudentDetails));



// WEBPACK FOOTER //
// ./app/components/student-details/index.js